import { FC } from 'react';
import { useIntl } from 'react-intl';
import { useEventGeneratorClickCta } from 'src/analytics/useEventGeneratorClickCta';
import { Button } from 'src/components';
import { useCtaHref } from 'src/hooks/useCtaHref';
import { useLanguagePairContext } from 'src/context/languagePair';
import { useTargetMessages } from 'src/hooks/useTargetMessages';
import * as localesWithMessages from './messages';
import * as S from './styles';

const Jumbotron: FC = () => {
  const intl = useIntl();
  const { sourceLanguageLocale } = useLanguagePairContext();

  const targetMsgs = useTargetMessages(localesWithMessages);

  const cta = intl.formatMessage(targetMsgs.cta);
  const text = intl.formatMessage(targetMsgs.text);
  const title = intl.formatMessage(targetMsgs.title);
  const topic = intl.formatMessage(targetMsgs.topic);

  const signUpHref = useCtaHref();
  const eventGeneratorClickCta = useEventGeneratorClickCta();

  return (
    <S.Section $sourceLanguageLocale={sourceLanguageLocale}>
      <S.SectionContent>
        <S.Card>
          <S.Topic>{topic}</S.Topic>
          <S.Title>{title}</S.Title>
          <S.Text>{text}</S.Text>
          <Button
            analyticsEvent={eventGeneratorClickCta}
            buttonSizeBreakpoint="md"
            buttonType="primary"
            disableMinWidth
            fullWidth="md"
            href={signUpHref}
          >
            {cta}
          </Button>
        </S.Card>
      </S.SectionContent>
    </S.Section>
  );
};

export default Jumbotron;
